<template>
    <div class="writecard table-hook fadeInRight">
        <div class="title-box">
            <span class="m-title">空中写号记录</span>
            <el-form
                inline
                class="hook right themed-form search-form"
                v-model="form"
                style="line-height: 40px"
            >
                <el-form-item label="EID:">
                    <el-input
                        v-model="form.eid"
                        placeholder="请输入EID"
                    ></el-input>
                </el-form-item>
                <el-form-item label="旧ICCID:">
                    <el-input
                        v-model="form.oldIccid"
                        placeholder="请输入旧ICCID"
                    ></el-input>
                </el-form-item>
                <el-form-item label="原接入号:">
                    <el-input
                        v-model="form.oldMsisdn"
                        placeholder="请输入原接入号"
                    ></el-input>
                </el-form-item>
                <el-form-item label="ICCID:">
                    <el-input
                        v-model="form.newIccid"
                        placeholder="请输入ICCID"
                    ></el-input>
                </el-form-item>
                <el-form-item label="接入号:">
                    <el-input
                        v-model="form.newMsisdn"
                        placeholder="请输入接入号"
                    ></el-input>
                </el-form-item>
                <el-form-item label="申请编号:">
                    <el-input
                        v-model="form.applyNo"
                        placeholder="请输入申请编号"
                    ></el-input>
                </el-form-item>
                <el-form-item label="省份:">
                    <el-select v-model="form.province" placeholder="请选择">
                        <el-option label="全部" value=""></el-option>
                        <el-option
                            v-for="(label, value) in provinceMap"
                            :key="value"
                            :label="label"
                            :value="label"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="代理商:">
                    <el-select
                        v-model="form.agentId"
                        filterable
                        clearable
                        placeholder="请选择代理商"
                    >
                        <el-option
                            v-for="item in agentThreeLists"
                            :key="item.agentId"
                            :label="item.agentName"
                            :value="item.agentId"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="状态:">
                    <el-select v-model="form.status" placeholder="请选择">
                        <el-option label="全部" value=""></el-option>
                        <el-option label="写号中" value="0"></el-option>
                        <el-option label="已写号" value="1"></el-option>
                        <el-option label="写号失败" value="2"></el-option>
                        <el-option label="已取消" value="3"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="开始时间:">
                    <el-date-picker
                        type="datetime"
                        placeholder="请选择日期时间"
                        v-model="form.startTime"
                        style="width: 100%"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        format="yyyy-MM-dd HH:mm:ss"
                    ></el-date-picker>
                </el-form-item>

                <el-form-item label="结束时间:">
                    <el-date-picker
                        type="datetime"
                        placeholder="请选择日期时间"
                        v-model="form.endTime"
                        style="width: 100%"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        format="yyyy-MM-dd HH:mm:ss"
                    ></el-date-picker>
                </el-form-item>

                <el-form-item>
                    <el-button
                        type="primary"
                        icon="el-icon-search"
                        class="themed-button"
                        @click="searchData"
                        >查询</el-button
                    >
                </el-form-item>

                <el-form-item>
                    <el-button
                        type="primary"
                        icon="el-icon-back"
                        class="themed-button"
                        @click="exportExcel"
                        >导出</el-button
                    >
                </el-form-item>

                <el-form-item>
                    <el-button
                        type="primary"
                        icon="el-icon-refresh"
                        class="themed-button"
                        @click="openBatchUpdateDialog"
                        >批量更新状态</el-button
                    >
                </el-form-item>

                <el-form-item>
                    <el-button
                        type="primary"
                        icon="el-icon-close"
                        class="themed-button"
                        @click="openBatchCancelDialog"
                        >批量取消写号</el-button
                    >
                </el-form-item>

                <el-form-item v-if="isAdmin">
                    <el-button
                        type="primary"
                        icon="el-icon-plus"
                        class="themed-button"
                        @click="importData"
                        >导入</el-button
                    >
                </el-form-item>

                <el-form-item v-if="isAdmin">
                    <el-button
                        type="primary"
                        icon="el-icon-edit-outline"
                        class="themed-button"
                        @click="openManualSupplementDialog"
                        >人工补录</el-button
                    >
                </el-form-item>
            </el-form>
        </div>

        <div class="content-box">
            <el-table
                ref="table"
                :data="tableData"
                stripe
                border
                :max-height="maxTableHeight"
            >
                <el-table-column
                    label="EID"
                    prop="eid"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    label="原接入号"
                    prop="oldMsisdn"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    label="旧ICCID"
                    prop="oldIccid"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    label="新接入号"
                    prop="newMsisdn"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    label="新ICCID"
                    prop="newIccid"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    label="IP"
                    prop="ip"
                    show-overflow-tooltip
                ></el-table-column>

                <el-table-column
                    label="状态"
                    prop="status"
                    show-overflow-tooltip
                >
                    <template slot-scope="scope">
                        {{ formatStatus(scope.row.status) }}
                    </template>
                </el-table-column>
                <el-table-column
                    label="申请编号"
                    prop="applyNo"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    label="省份"
                    prop="province"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    label="代理商"
                    prop="agentName"
                    show-overflow-tooltip
                >
                    <template slot-scope="scope">
                        <span
                            v-if="
                                scope.row.agentName &&
                                scope.row.agentName.trim() !== ''
                            "
                        >
                            {{ scope.row.agentName }}
                        </span>
                        <span v-else>
                            <el-tag type="info">未分销</el-tag>
                        </span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="操作人"
                    prop="operatorName"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    label="创建时间"
                    prop="createTime"
                    show-overflow-tooltip
                >
                    <template slot-scope="scope">
                        {{ formatDateTime(scope.row.createTime) }}
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="180" fixed="right">
                    <template slot-scope="scope">
                        <el-button
                            v-if="!scope.row.ip && scope.row.status === 0"
                            type="primary"
                            class="themed-button"
                            size="mini"
                            :loading="loadingMap[scope.row.applyNo + '_cancel']"
                            :disabled="
                                disabledMap[scope.row.applyNo + '_cancel']
                            "
                            @click="handleCancel(scope.row)"
                        >
                            取消写号
                        </el-button>
                        <el-button
                            v-if="
                                (!scope.row.ip || scope.row.ip.trim() === '') &&
                                scope.row.status !== 3
                            "
                            type="primary"
                            class="themed-button"
                            size="mini"
                            :loading="loadingMap[scope.row.applyNo + '_update']"
                            :disabled="
                                disabledMap[scope.row.applyNo + '_update']
                            "
                            @click="handleUpdateStatus(scope.row)"
                        >
                            更新状态
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <div class="pagination">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[15, 30, 50, 100]"
                :page-size="pageSize"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
            >
            </el-pagination>
        </div>

        <!-- 导入弹框 -->
        <el-dialog
            title="批量导入"
            :visible.sync="importDialogVisible"
            width="600px"
        >
            <el-form
                label-position="right"
                label-width="180px"
                style="max-height: 500px; overflow: auto"
            >
                <el-form-item label="上传文件（excel）:" required>
                    <input class="file-input" type="file" ref="importFile" />
                    <div class="mt5">
                        <span class="text-color" style="font-size: 12px"
                            >仅支持.xls/.xlsx格式</span
                        >
                    </div>
                </el-form-item>
                <el-form-item label="设备卡信息:">
                    <el-input
                        v-model="importCardInfo"
                        type="textarea"
                        rows="6"
                        placeholder="请输入EID 新ICCID 新接入号 ，每行一组，用空格分开"
                    ></el-input>
                    <div style="color: #f00">
                        请输入EID 新ICCID 新接入号 ，每行一组，用空格分开
                    </div>
                </el-form-item>
            </el-form>
            <div class="align-right">
                <el-button
                    type="primary"
                    class="themed-button"
                    @click="submitImport"
                    >导入excel模板</el-button
                >
                <el-button
                    type="primary"
                    class="themed-button"
                    @click="exportTemplate"
                    >导出excel模板</el-button
                >
                <el-button
                    type="primary"
                    class="themed-button"
                    @click="importDialogVisible = false"
                    >取 消</el-button
                >
            </div>
        </el-dialog>

        <!-- 批量更新状态弹框 -->
        <el-dialog
            title="批量更新状态"
            :visible.sync="batchUpdateDialogVisible"
            width="600px"
        >
            <el-form
                label-position="right"
                label-width="180px"
                style="max-height: 500px; overflow: auto"
            >
                <el-form-item label="上传文件（excel）:">
                    <input
                        class="file-input"
                        type="file"
                        ref="batchUpdateFile"
                    />
                    <div class="mt5">
                        <span class="text-color" style="font-size: 12px"
                            >仅支持.xls/.xlsx格式</span
                        >
                    </div>
                </el-form-item>
                <el-form-item label="申请编号:">
                    <el-input
                        v-model="batchUpdateApplyNos"
                        type="textarea"
                        rows="6"
                        placeholder="请输入申请编号，每行一个"
                    ></el-input>
                    <div style="color: #f00">请输入申请编号，每行一个</div>
                </el-form-item>
            </el-form>
            <div class="align-right">
                <el-button
                    type="primary"
                    class="themed-button"
                    @click="submitBatchUpdate"
                    >确 定</el-button
                >
                <el-button
                    type="primary"
                    class="themed-button"
                    @click="exportBatchUpdateTemplate"
                    >导出excel模板</el-button
                >
                <el-button
                    type="primary"
                    class="themed-button"
                    @click="batchUpdateDialogVisible = false"
                    >取 消</el-button
                >
            </div>
        </el-dialog>

        <!-- 批量取消写号弹框 -->
        <el-dialog
            title="批量取消写号"
            :visible.sync="batchCancelDialogVisible"
            width="600px"
        >
            <el-form
                label-position="right"
                label-width="180px"
                style="max-height: 500px; overflow: auto"
            >
                <el-form-item label="上传文件（excel）:">
                    <input
                        class="file-input"
                        type="file"
                        ref="batchCancelFile"
                    />
                    <div class="mt5">
                        <span class="text-color" style="font-size: 12px"
                            >仅支持.xls/.xlsx格式</span
                        >
                    </div>
                </el-form-item>
                <el-form-item label="申请编号:">
                    <el-input
                        v-model="batchCancelApplyNos"
                        type="textarea"
                        rows="6"
                        placeholder="请输入申请编号，每行一个"
                    ></el-input>
                    <div style="color: #f00">请输入申请编号，每行一个</div>
                </el-form-item>
            </el-form>
            <div class="align-right">
                <el-button
                    type="primary"
                    class="themed-button"
                    @click="submitBatchCancel"
                    >确 定</el-button
                >
                <el-button
                    type="primary"
                    class="themed-button"
                    @click="exportBatchCancelTemplate"
                    >导出excel模板</el-button
                >
                <el-button
                    type="primary"
                    class="themed-button"
                    @click="batchCancelDialogVisible = false"
                    >取 消</el-button
                >
            </div>
        </el-dialog>

        <!-- 人工补录 -->
        <el-dialog
            title="人工补录"
            :visible.sync="manualSupplementDialogVisible"
            width="640px"
        >
            <el-form
                label-position="right"
                label-width="140px"
                style="max-height: 520px; overflow: auto"
            >
                <el-form-item label="上传文件（excel）:">
                    <input
                        class="file-input"
                        type="file"
                        ref="manualSupplementFile"
                    />
                    <div class="mt5">
                        <span class="text-color" style="font-size: 12px"
                            >仅支持.xls/.xlsx格式，字段顺序与文本补录一致</span
                        >
                    </div>
                </el-form-item>
                <el-form-item label="文本补录:">
                    <el-input
                        v-model="manualSupplementText"
                        type="textarea"
                        rows="8"
                        placeholder="每行一条记录，字段之间使用 空格或英文逗号 分隔。顺序：EID、原接入号、原ICCID、新接入号、新ICCID、写号状态、申请编号、省份、创建时间"
                    ></el-input>
                    <div
                        style="color: #f56c6c; font-size: 12px; margin-top: 6px"
                    >
                        创建时间格式示例：2026-01-15
                        10:30:00。可选择仅上传文件或仅填写文本，也可同时提交。
                    </div>
                </el-form-item>
            </el-form>
            <div class="align-right">
                <el-button
                    type="primary"
                    class="themed-button"
                    @click="submitManualSupplement"
                    >确定补录</el-button
                >
                <el-button
                    type="primary"
                    class="themed-button"
                    @click="exportManualSupplementTemplate"
                    >导出excel模板</el-button
                >
                <el-button
                    type="primary"
                    class="themed-button"
                    @click="manualSupplementDialogVisible = false"
                    >取 消</el-button
                >
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {
    listWriteCard,
    exportWriteCardSync,
    importExcel,
    cancelWriteCardApply,
    queryAndUpdateWriteCardStatus,
    batchUpdateWriteCardStatus,
    batchCancelWriteCardApply,
    manualSupplementWriteCardRecord,
} from "@/api/writeCardManagement/writecard.js";
import { agentListForUser } from "@/api/cardManagement/cardBill.js";
import { messageBox } from "@/utils/common.js";
import resize from "@/mixins/resize.js";
import Utils from "@/utils/utils.js";
import { exportTemplate } from "@/api/statistics.js";
import { mapGetters } from "vuex";

export default {
    name: "writecard",
    mixins: [resize],
    computed: {
        ...mapGetters(["currentRole", "currentAgentId"]),
        // 是否是管理员角色
        isAdmin() {
            return this.currentRole == 0;
        },
    },
    data() {
        return {
            form: {
                eid: "",
                oldIccid: "",
                oldMsisdn: "",
                newIccid: "",
                newMsisdn: "",
                status: "",
                startTime: "",
                endTime: "",
                applyNo: "",
                province: "",
                agentId: "",
            },
            agentThreeLists: [],
            tableData: [],
            pageSize: 15,
            currentPage: 1,
            total: 0,
            maxTableHeight: 500,

            // 添加loading状态变量
            loadingMap: {}, // 用于存储每行按钮的loading状态
            // 添加防重复点击状态变量
            disabledMap: {}, // 用于存储每行按钮的禁用状态

            // 省份映射数据
            provinceMap: {
                北京市: "北京市",
                天津市: "天津市",
                河北省: "河北省",
                山西省: "山西省",
                内蒙古自治区: "内蒙古自治区",
                辽宁省: "辽宁省",
                吉林省: "吉林省",
                黑龙江省: "黑龙江省",
                上海市: "上海市",
                江苏省: "江苏省",
                浙江省: "浙江省",
                安徽省: "安徽省",
                福建省: "福建省",
                江西省: "江西省",
                山东省: "山东省",
                河南省: "河南省",
                湖北省: "湖北省",
                湖南省: "湖南省",
                广东省: "广东省",
                广西壮族自治区: "广西壮族自治区",
                海南省: "海南省",
                重庆市: "重庆市",
                四川省: "四川省",
                贵州省: "贵州省",
                云南省: "云南省",
                西藏自治区: "西藏自治区",
                陕西省: "陕西省",
                甘肃省: "甘肃省",
                青海省: "青海省",
                宁夏回族自治区: "宁夏回族自治区",
                新疆维吾尔自治区: "新疆维吾尔自治区",
                台湾省: "台湾省",
                香港特别行政区: "香港特别行政区",
                澳门特别行政区: "澳门特别行政区",
                全国: "全国",
            },

            // 状态映射
            statusMap: {
                0: "写号中",
                1: "已写号",
                2: "写号失败",
                3: "已取消",
            },

            // 导入弹框数据
            importDialogVisible: false,
            importCardInfo: "",

            // 批量更新状态弹框数据
            batchUpdateDialogVisible: false,
            batchUpdateApplyNos: "", // 申请编号文本

            // 批量取消写号弹框数据
            batchCancelDialogVisible: false,
            batchCancelApplyNos: "", // 申请编号文本

            // 人工补录
            manualSupplementDialogVisible: false,
            manualSupplementText: "",
        };
    },
    mounted() {
        this.getAgentListForUser();
        this.getList();
    },
    activated() {
        this.getList();
    },
    methods: {
        // 获取代理商列表
        getAgentListForUser() {
            agentListForUser()
                .then((res) => {
                    this.agentThreeLists = res || [];
                })
                .catch((err) => {
                    console.error("获取代理商列表失败:", err);
                    this.agentThreeLists = [];
                });
        },
        // 获取列表数据
        getList() {
            const params = {
                pageSize: this.pageSize,
                pageNo: this.currentPage,
                ...this.form,
            };

            listWriteCard(params).then((res) => {
                if (res && res.page) {
                    this.tableData = res.page.rows || [];
                    this.total = res.page.total || 0;
                }
            });
        },

        // 搜索
        searchData() {
            this.currentPage = 1;
            this.getList();
        },

        // 分页处理
        handleSizeChange(val) {
            this.pageSize = val;
            this.getList();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getList();
        },

        // 导出
        exportExcel() {
            // 导出参数包含代理商(agentId)字段
            const params = Object.assign({}, this.form);
            exportWriteCardSync(params).then((res) => {
                if (res.system_result_key == "0") {
                    this.$alert("导出成功，请到导出记录中下载", "提示", {
                        confirmButtonText: "确定",
                    }).then(() => {
                        this.$router.push("/tob/i_export_list");
                    });
                } else {
                    this.$message({
                        showClose: true,
                        message: res.system_result_message_key,
                        type: "error",
                    });
                }
            });
        },

        // 导入操作
        importData() {
            this.importDialogVisible = true;
        },

        // 提交导入
        submitImport() {
            // 二次确认提示
            this.$confirm(
                "确认要进行导入操作吗？\n\n温馨提示：写号申请成功后会更新旧卡号信息为新卡号信息",
                "确认导入",
                {
                    confirmButtonText: "确定导入",
                    cancelButtonText: "取消",
                    type: "warning",
                    dangerouslyUseHTMLString: false,
                }
            )
                .then(() => {
                    // 执行实际导入逻辑
                    this.executeImport();
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消导入操作",
                    });
                });
        },

        // 执行实际导入操作
        executeImport() {
            let file = this.$refs["importFile"].files[0];
            let formData = new FormData();

            // 处理卡信息
            if (!file && !this.importCardInfo.trim()) {
                messageBox(this, "请选择文件或输入号卡信息");
                return;
            }

            // 如果有文件，检查文件格式并添加到表单
            if (file) {
                let fileName = file.name;
                let index = fileName.lastIndexOf(".");
                if (
                    index < 0 ||
                    !(
                        fileName.substring(index + 1, fileName.length) ==
                            "xls" ||
                        fileName.substring(index + 1, fileName.length) == "xlsx"
                    )
                ) {
                    messageBox(this, "文件格式错误");
                    return;
                }
                formData.append("fileurl", file);
            }

            // 无论是否有文件，都添加卡信息到表单
            formData.append("phones", this.importCardInfo);

            importExcel(formData).then((res) => {
                if (res.system_result_key == "0") {
                    if (file) {
                        // 有Excel文件上传，跳转到导入记录页面
                        const successMessage =
                            res.system_result_message_key ||
                            "导入成功，请到导入记录中下载";
                        this.$alert(successMessage, "提示", {
                            confirmButtonText: "确定",
                        }).then(() => {
                            this.$refs["importFile"].value = "";
                            this.importCardInfo = "";
                            this.importDialogVisible = false;
                            this.$router.push("/tob/i_import_list");
                        });
                    } else {
                        // 无Excel文件上传，只刷新当前列表
                        const successMessage =
                            res.system_result_message_key || "导入成功";
                        this.$message({
                            showClose: true,
                            message: successMessage,
                            type: "success",
                        });
                        this.importCardInfo = "";
                        this.importDialogVisible = false;
                        this.getList(); // 刷新列表数据
                    }
                } else {
                    this.$message({
                        showClose: true,
                        message: res.system_result_message_key,
                        type: "error",
                    });
                }
            });
        },

        // 导出模板
        exportTemplate() {
            exportTemplate({ name: "importWriteCard.xls" }).then((res) => {
                const filename = "importWriteCard.xls";
                Utils.createDownload(res, filename);
            });
        },

        // 格式化状态
        formatStatus(status) {
            return this.statusMap[status] || "未知状态";
        },

        // 格式化日期时间
        formatDateTime(dateTime) {
            if (!dateTime) return "-";

            try {
                // 处理ISO格式的时间字符串
                const date = new Date(dateTime);
                if (isNaN(date.getTime())) return dateTime;

                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, "0");
                const day = String(date.getDate()).padStart(2, "0");
                const hours = String(date.getHours()).padStart(2, "0");
                const minutes = String(date.getMinutes()).padStart(2, "0");
                const seconds = String(date.getSeconds()).padStart(2, "0");

                return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
            } catch (error) {
                console.error("日期格式化错误:", error);
                return dateTime;
            }
        },

        // 取消写号操作
        handleCancel(row) {
            // 检查是否在禁用状态
            if (this.disabledMap[row.applyNo + "_cancel"]) {
                return;
            }

            // 设置loading状态和禁用状态
            this.$set(this.loadingMap, row.applyNo + "_cancel", true);
            this.$set(this.disabledMap, row.applyNo + "_cancel", true);

            this.$confirm(
                "确认要取消该写号操作吗？\n\n温馨提示：取消申请写号成功，新卡号信息会恢复成旧卡号信息。",
                "确认取消写号",
                {
                    confirmButtonText: "确定取消",
                    cancelButtonText: "取消",
                    type: "warning",
                }
            )
                .then(() => {
                    cancelWriteCardApply({
                        applyNo: row.applyNo,
                    })
                        .then((res) => {
                            if (res.system_result_key === "0") {
                                this.$message({
                                    type: "success",
                                    message:
                                        res.system_result_message_key ||
                                        "取消成功",
                                });
                                this.getList(); // 刷新列表
                            } else {
                                this.$message({
                                    type: "error",
                                    message:
                                        res.system_result_message_key ||
                                        "取消失败",
                                });
                            }
                        })
                        .finally(() => {
                            // 无论成功失败都要清除loading状态
                            this.$set(
                                this.loadingMap,
                                row.applyNo + "_cancel",
                                false
                            );
                            // 10秒后清除禁用状态
                            setTimeout(() => {
                                this.$set(
                                    this.disabledMap,
                                    row.applyNo + "_cancel",
                                    false
                                );
                            }, 10000);
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消操作",
                    });
                    // 用户取消也要清除loading状态和禁用状态
                    this.$set(this.loadingMap, row.applyNo + "_cancel", false);
                    this.$set(this.disabledMap, row.applyNo + "_cancel", false);
                });
        },

        // 更新状态操作
        handleUpdateStatus(row) {
            // 检查是否在禁用状态
            if (this.disabledMap[row.applyNo + "_update"]) {
                return;
            }

            // 设置loading状态和禁用状态
            this.$set(this.loadingMap, row.applyNo + "_update", true);
            this.$set(this.disabledMap, row.applyNo + "_update", true);

            this.$confirm("确认要查询并更新该写号状态吗？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    queryAndUpdateWriteCardStatus({
                        applyNo: row.applyNo,
                    })
                        .then((res) => {
                            if (res.system_result_key === "0") {
                                this.$message({
                                    type: "success",
                                    message:
                                        res.system_result_message_key ||
                                        "状态更新成功",
                                });
                                this.getList(); // 刷新列表
                            } else {
                                this.$message({
                                    type: "error",
                                    message:
                                        res.system_result_message_key ||
                                        "状态更新失败",
                                });
                            }
                        })
                        .finally(() => {
                            // 无论成功失败都要清除loading状态
                            this.$set(
                                this.loadingMap,
                                row.applyNo + "_update",
                                false
                            );
                            // 10秒后清除禁用状态
                            setTimeout(() => {
                                this.$set(
                                    this.disabledMap,
                                    row.applyNo + "_update",
                                    false
                                );
                            }, 10000);
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消操作",
                    });
                    // 用户取消也要清除loading状态和禁用状态
                    this.$set(this.loadingMap, row.applyNo + "_update", false);
                    this.$set(this.disabledMap, row.applyNo + "_update", false);
                });
        },

        // 打开批量更新状态对话框
        openBatchUpdateDialog() {
            this.batchUpdateDialogVisible = true;
            // 清空表单
            this.$nextTick(() => {
                if (this.$refs["batchUpdateFile"]) {
                    this.$refs["batchUpdateFile"].value = "";
                }
            });
            this.batchUpdateApplyNos = "";
        },

        // 导出批量更新状态模板
        exportBatchUpdateTemplate() {
            exportTemplate({ name: "importApplyNo.xls" }).then((res) => {
                const filename = "importApplyNo.xls";
                Utils.createDownload(res, filename);
            });
        },

        // 提交批量更新状态
        submitBatchUpdate() {
            let file = this.$refs["batchUpdateFile"].files[0];
            let formData = new FormData();

            // 处理申请编号信息
            if (!file && !this.batchUpdateApplyNos.trim()) {
                messageBox(this, "请选择文件或输入申请编号");
                return;
            }

            // 如果有文件，检查文件格式并添加到表单
            if (file) {
                let fileName = file.name;
                let index = fileName.lastIndexOf(".");
                if (
                    index < 0 ||
                    !(
                        fileName.substring(index + 1, fileName.length) ==
                            "xls" ||
                        fileName.substring(index + 1, fileName.length) == "xlsx"
                    )
                ) {
                    messageBox(this, "文件格式错误");
                    return;
                }
                formData.append("fileurl", file);
            }

            // 无论是否有文件，都添加申请编号到表单
            if (this.batchUpdateApplyNos.trim()) {
                formData.append("applyNos", this.batchUpdateApplyNos.trim());
            }

            // 二次确认提示
            this.$confirm("确认要批量更新写号状态吗？", "批量更新状态", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    batchUpdateWriteCardStatus(formData)
                        .then((res) => {
                            if (res.system_result_key == "0") {
                                // 解析返回消息，提取失败数量
                                const message =
                                    res.system_result_message_key ||
                                    "批量更新完成";
                                this.$alert(message, "提示", {
                                    confirmButtonText: "确定",
                                }).then(() => {
                                    // 清空表单
                                    if (this.$refs["batchUpdateFile"]) {
                                        this.$refs["batchUpdateFile"].value =
                                            "";
                                    }
                                    this.batchUpdateApplyNos = "";
                                    this.batchUpdateDialogVisible = false;
                                    this.getList(); // 刷新列表
                                });
                            } else {
                                this.$message({
                                    showClose: true,
                                    message: res.system_result_message_key,
                                    type: "error",
                                });
                            }
                        })
                        .catch((error) => {
                            console.error("批量更新失败:", error);
                            this.$message({
                                showClose: true,
                                message: "批量更新失败，请重试",
                                type: "error",
                            });
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消批量更新操作",
                    });
                });
        },

        // 打开人工补录对话框
        openManualSupplementDialog() {
            this.manualSupplementDialogVisible = true;
            this.manualSupplementText = "";
            this.$nextTick(() => {
                if (this.$refs["manualSupplementFile"]) {
                    this.$refs["manualSupplementFile"].value = "";
                }
            });
        },

        // 导出人工补录 Excel 模板（与后端 downloadTemp.do 约定文件名）
        exportManualSupplementTemplate() {
            const filename = "manualSupplementimport.xlsx";
            exportTemplate({ name: filename }).then((res) => {
                Utils.createDownload(res, filename);
            });
        },

        // 提交人工补录
        submitManualSupplement() {
            const file = this.$refs["manualSupplementFile"]
                ? this.$refs["manualSupplementFile"].files[0]
                : null;
            const text = (this.manualSupplementText || "").trim();

            if (!file && !text) {
                messageBox(this, "请选择文件或填写文本补录内容");
                return;
            }

            if (file) {
                const fileName = file.name;
                const index = fileName.lastIndexOf(".");
                if (
                    index < 0 ||
                    !(
                        fileName.substring(index + 1, fileName.length) ===
                            "xls" ||
                        fileName.substring(index + 1, fileName.length) ===
                            "xlsx"
                    )
                ) {
                    messageBox(this, "文件格式错误");
                    return;
                }
            }

            const formData = new FormData();
            if (file) {
                formData.append("fileurl", file);
            }
            if (text) {
                formData.append("supplementText", text);
            }

            this.$confirm(
                "确认提交人工补录吗？请核对 Excel 或文本内容是否正确。",
                "人工补录",
                {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                }
            )
                .then(() => {
                    manualSupplementWriteCardRecord(formData)
                        .then((res) => {
                            if (res.system_result_key == "0") {
                                this.$message({
                                    showClose: true,
                                    message:
                                        res.system_result_message_key ||
                                        "补录成功",
                                    type: "success",
                                });
                                if (this.$refs["manualSupplementFile"]) {
                                    this.$refs["manualSupplementFile"].value =
                                        "";
                                }
                                this.manualSupplementText = "";
                                this.manualSupplementDialogVisible = false;
                                this.getList();
                            } else {
                                this.$message({
                                    showClose: true,
                                    message: res.system_result_message_key,
                                    type: "error",
                                });
                            }
                        })
                        .catch((error) => {
                            console.error("人工补录失败:", error);
                            this.$message({
                                showClose: true,
                                message: "人工补录失败，请重试",
                                type: "error",
                            });
                        });
                })
                .catch(() => {});
        },

        // 打开批量取消写号对话框
        openBatchCancelDialog() {
            this.batchCancelDialogVisible = true;
            this.$nextTick(() => {
                if (this.$refs["batchCancelFile"]) {
                    this.$refs["batchCancelFile"].value = "";
                }
            });
            this.batchCancelApplyNos = "";
        },

        // 导出批量取消写号模板
        exportBatchCancelTemplate() {
            exportTemplate({ name: "importApplyNo.xls" }).then((res) => {
                const filename = "importApplyNo.xls";
                Utils.createDownload(res, filename);
            });
        },

        // 提交批量取消写号
        submitBatchCancel() {
            let file = this.$refs["batchCancelFile"].files[0];
            let formData = new FormData();

            console.log(file);

            // 处理申请编号信息
            if (!file && !this.batchCancelApplyNos.trim()) {
                messageBox(this, "请选择文件或输入申请编号");
                return;
            }

            // 如果有文件，检查文件格式并添加到表单
            if (file) {
                let fileName = file.name;
                let index = fileName.lastIndexOf(".");
                if (
                    index < 0 ||
                    !(
                        fileName.substring(index + 1, fileName.length) ==
                            "xls" ||
                        fileName.substring(index + 1, fileName.length) == "xlsx"
                    )
                ) {
                    messageBox(this, "文件格式错误");
                    return;
                }
                formData.append("fileurl", file);
            }

            // 无论是否有文件，都添加申请编号到表单
            if (this.batchCancelApplyNos.trim()) {
                formData.append(
                    "applyNosText",
                    this.batchCancelApplyNos.trim()
                );
            }

            // 二次确认提示
            this.$confirm(
                "确认要批量取消写号吗？\n\n温馨提示：取消申请写号成功，新卡号信息会恢复成旧卡号信息。",
                "批量取消写号",
                {
                    confirmButtonText: "确定取消",
                    cancelButtonText: "取消",
                    type: "warning",
                }
            )
                .then(() => {
                    batchCancelWriteCardApply(formData)
                        .then((res) => {
                            if (res.system_result_key == "0") {
                                // 解析返回消息，提取失败数量
                                const message =
                                    res.system_result_message_key ||
                                    "批量取消完成";
                                this.$alert(message, "提示", {
                                    confirmButtonText: "确定",
                                }).then(() => {
                                    // 清空表单
                                    if (this.$refs["batchCancelFile"]) {
                                        this.$refs["batchCancelFile"].value =
                                            "";
                                    }
                                    this.batchCancelApplyNos = "";
                                    this.batchCancelDialogVisible = false;
                                    this.getList(); // 刷新列表
                                });
                            } else {
                                this.$message({
                                    showClose: true,
                                    message: res.system_result_message_key,
                                    type: "error",
                                });
                            }
                        })
                        .catch((error) => {
                            console.error("批量取消写号失败:", error);
                            this.$message({
                                showClose: true,
                                message: "批量取消写号失败，请重试",
                                type: "error",
                            });
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消批量取消写号操作",
                    });
                });
        },
    },
};
</script>

<style scoped>
::v-deep .el-table .cell {
    padding: 0;
}
.writecard {
    padding: 20px;
}

.content-box {
    margin-bottom: 20px;
}

.pagination {
    text-align: right;
    margin-top: 20px;
}

.file-input {
    display: inline-block;
}

.mt5 {
    margin-top: 5px;
}

.align-right {
    text-align: right;
    margin-top: 20px;
}

.text-color {
    color: #606266;
}

.info-box {
    padding: 10px;
    background-color: #f0f0f0;
    border-radius: 4px;
}
</style> 